<script>
import Component from '~/sites/soh/pages/_'
export default {
  extends: Component,
}
</script>
